import React, { useState } from "react";
import { Bar, Pie } from "react-chartjs-2";
import states from "../utils/states";

const DeltaGraph = ({ stateinfo }) => {
  const [currentState, setCurrentState] = useState("TT");
  const data = {
    labels: ["Confirmed", "Recovered", "Deceased"],
    datasets: [
      {
        label: "Cases",
        data: stateinfo ? [stateinfo[currentState]["delta7"].confirmed, stateinfo[currentState]["delta7"].recovered, stateinfo[currentState]["delta7"].deceased] : [0, 0, 0, 0],
        backgroundColor: ["#ff1744", "#46b464", "grey"],
        borderColor: ["#ff1744", "#46b464", "grey"],
        borderWidth: 1,
        borderRadius: 10,
        barThickness: 30,
      },
    ],
  };
  const populationData = {
    labels: ["Unvaccinated", "Vaccinated"],
    datasets: [
      {
        label: "Total",
        data: stateinfo ? [stateinfo[currentState]["meta"].population - stateinfo[currentState]["total"].vaccinated1, stateinfo[currentState]["total"].vaccinated1] : [0, 0, 0, 0],
        backgroundColor: ["#607d8b", "#0070f3"],
      },
    ],
  };
  const options = {
    scales: {
      x: {
        grid: {
          display: true,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    indexAxis: "y",
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "7 Day Moving Average",
      },
    },
  };
  const populationOptions = {
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "% Population Vaccinated",
      },
    },
  };

  return (
    <div className="deltagraph">
      <select
        name="state"
        id="state"
        onChange={(e) => {
          setCurrentState(e.target.value);
        }}
      >
        {Object.keys(states).map((el, i) => {
          return <option value={el} key={i}>{states[el]}</option>;
        })}
      </select>
      <div className="graphs">
        {stateinfo ? <Bar data={data} options={options}></Bar> : null}
        <div id="piechart">{stateinfo ? <Pie data={populationData} options={populationOptions}></Pie> : null}</div>
      </div>
    </div>
  );
};

export default DeltaGraph;
